<template>
  <nav-bar title="未检查" />
  <Content :bottom="0">
    <ul class="list">
      <li class="list-item" v-for="item in list" :key="item.userId">
        <span>{{ item.companyName }}</span>
        <van-button
          size="small"
          @click="
            $router.push(`/inspection/${item.userId}/${item.companyName}`)
          "
          >检查</van-button
        >
      </li>
    </ul>
  </Content>
</template>

<script>
import { useStore } from 'vuex'
import { getNotCheckListByDeptId } from '@/api/salehome'
import { computed, ref } from 'vue'
import { useGetData } from '@/hooks/useGetData'
export default {
  name: 'NotChecked',
  setup() {
    const store = useStore()
    const departId = computed(() => store.state.roleInfo.departId)
    const list = ref([])
    useGetData(getNotCheckListByDeptId, data => {
      list.value = data
    })(departId.value)
    return { list }
  }
}
</script>

<style lang="scss" scoped>
.list {
  padding: 16px;
  font-size: 14px;
  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    border-bottom: 0.5px solid #fff;
    padding-bottom: 10px;
  }
}
</style>
